import React from 'react';
import PropTypes from 'prop-types';
import { Progress, Button } from 'rsuite';

const DeckSummary = ({
  tableData,
  priceLoading,
  cardLoading,
  priceSummary,
  totalPages,
  currentPageNum,
  paginationProgress,
  canEdit,
  COLORS,
  onRefreshPrices,
  refreshing,
  refreshProgress,
}) => {
  return (
    <>
      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'center' }}>
        {(priceLoading || cardLoading || refreshing) && (
          <span style={{ fontSize: 13, color: COLORS.muted }}>
            {refreshing ? (
              <>Refreshing prices... {refreshProgress.done} / {refreshProgress.total}</>
            ) : totalPages > 1 && currentPageNum > 0 ? (
              <>Loading page {currentPageNum} of {totalPages}...</>
            ) : (
              <>Fetching prices...</>
            )}
          </span>
        )}
        {!refreshing && totalPages > 1 && paginationProgress > 0 && paginationProgress < 1 && (
          <div style={{ width: 200, marginLeft: 8 }}>
            <Progress.Line
              percent={Math.round(paginationProgress * 100)}
              status="active"
            />
          </div>
        )}
      </div>
      {tableData.length > 0 && !priceLoading && (
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginTop: 8, marginBottom: 12, fontSize: 13, alignItems: 'center' }}>
          {canEdit && <span>Purchase Value: <strong>${priceSummary.totalPurchase.toFixed(2)}</strong></span>}
          <span>Current Value: <strong>${priceSummary.totalCurrent.toFixed(2)}</strong></span>
          {canEdit && priceSummary.trackable.length > 0 && (
            <span>Gain/Loss: <strong style={{ color: priceSummary.glColor }}>{priceSummary.glPrefix}${priceSummary.totalGainLoss.toFixed(2)}</strong></span>
          )}
          {onRefreshPrices && (
            <Button size="xs" appearance="ghost" loading={refreshing} onClick={onRefreshPrices}>
              Refresh Prices
            </Button>
          )}
        </div>
      )}
    </>
  );
};

DeckSummary.propTypes = {
  tableData: PropTypes.array.isRequired,
  priceLoading: PropTypes.bool,
  cardLoading: PropTypes.bool,
  priceSummary: PropTypes.object.isRequired,
  totalPages: PropTypes.number,
  currentPageNum: PropTypes.number,
  paginationProgress: PropTypes.number,
  canEdit: PropTypes.bool,
  COLORS: PropTypes.object.isRequired,
  onRefreshPrices: PropTypes.func,
  refreshing: PropTypes.bool,
  refreshProgress: PropTypes.object,
};

DeckSummary.defaultProps = {
  priceLoading: false,
  cardLoading: false,
  totalPages: 0,
  currentPageNum: 0,
  paginationProgress: 0,
  canEdit: false,
  refreshing: false,
  refreshProgress: { done: 0, total: 0 },
};

export default DeckSummary;
